import styled from "styled-components";

export const ActionDescriptionRow = styled.div`
    && {
        height: 32px;
        padding: 4px 10px;
        border: none;
        border-radius: 0;
        display: flex;
        align-items: center;
        min-height: auto !important;
    }
`;

export const PriorityDot = styled.div<{ color: string }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
`;

export const ChipTag = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 2px 8px;
    background-color: #ffffff;
`;

export const ActionSeparator = styled.div`
    width: 1px;
    height: 10px;
    background: #e0e0e0;
    margin: 2px 0px 2px 15px;
`;
